import React, { useState } from 'react';
import LabelCanvas from '../../LabelView/LabelCanvas';
import { isGIVariant } from '../../../components/gi-label/giThemes';

function PreviewPanel({
  identity,
  visible,
  mobileView,
  labelName,
  backgroundImage,
  backgroundColor,
  borderColor,
  labelMeta,
  contentItems,
}) {
  const [previewSize, setPreviewSize] = useState('wide');
  const isGI = isGIVariant(labelMeta?.templateVariant);
  if (!visible) return null;

  const previewLabelData = {
    id: identity?.id ?? identity?.labelId,
    createTime: identity?.createTime || identity?.createdAt,
    labelName: labelName || '',
    backgroundImage,
    backgroundColor,
    borderColor,
    meta: labelMeta,
    contentItems: contentItems.map((item, index) => ({
      contentType: item.type,
      contentData: item.data,
      sortOrder: index + 1,
    })),
  };

  return (
    <div className={`preview-panel ${mobileView === 'preview' ? 'mobile-active' : 'mobile-hidden'} ${isGI ? `gi-preview-${previewSize}` : ''}`}>
      <div className="preview-container">
        <div className="preview-header">
          <div className="preview-title">实时预览</div>
          {isGI && <div className="gi-preview-size" role="group" aria-label="预览宽度">
            <button type="button" aria-pressed={previewSize === 'wide'} onClick={() => setPreviewSize('wide')}>宽屏</button>
            <button type="button" aria-pressed={previewSize === 'mobile'} onClick={() => setPreviewSize('mobile')}>手机</button>
          </div>}
        </div>
        <div className="preview-canvas-wrapper">
          <LabelCanvas data={previewLabelData} phonePreview />
        </div>
      </div>
    </div>
  );
}

export default PreviewPanel;
